<template>
  <li :title="attributeMatch.translation" :class="classes">
    <svg v-if="isMatch" class="products-item-matching-list-item-icon" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.5 13L14.1666 20L10.5 16.5" stroke="#1A542A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z" stroke="#1A542A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <svg v-else class="products-item-matching-list-item-icon" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z" stroke="black" stroke-width="2" stroke-miterlimit="10" />
      <path d="M11 16H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <span>{{ attributeMatch.translation }}</span>
  </li>
</template>

<script>
// @flow

export default {
  props: {
    attributeMatch: {
      type: Object, // AttributeMatch
      required: true
    }
  },
  computed: {
    isMatch (): boolean {
      return this.attributeMatch.utility > 0
    },
    classes (): Object {
      return {
        'products-item-matching-list-item': true,
        'products-item-matching-list-item--is-match': this.isMatch,
        'products-item-matching-list-item--is-mismatch': !this.isMatch
      }
    }
  }
}
</script>
